import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Lore() {
  const { t } = useLang();
  const CHAPTERS = [
    { year: t.lore.c1y, title: t.lore.c1t, body: t.lore.c1b },
    { year: t.lore.c2y, title: t.lore.c2t, body: t.lore.c2b },
    { year: t.lore.c3y, title: t.lore.c3t, body: t.lore.c3b },
    { year: t.lore.c4y, title: t.lore.c4t, body: t.lore.c4b },
  ];
  return (
    <div className="relative z-10 pt-28 pb-10">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="text-overline mb-4">{t.lore.tag}</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase tracking-tight max-w-3xl">
          {t.lore.title}
        </h1>
        <p className="mt-6 text-cosmic/70 max-w-2xl font-light leading-relaxed text-lg">
          {t.lore.intro}
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-10 mt-20">
        <div className="relative border-l border-cosmic/15 pl-8 md:pl-12 space-y-16">
          {CHAPTERS.map((c, i) => (
            <div key={i} className="relative fade-up" style={{ animationDelay: `${i * 0.12}s` }}>
              <div className="absolute -left-[34px] md:-left-[50px] top-1.5 w-3 h-3 rounded-full bg-portal shadow-[0_0_18px_#00D4FF]" />
              <div className="text-overline mb-2">{c.year}</div>
              <h3 className="font-display text-2xl md:text-3xl tracking-wide">{c.title}</h3>
              <p className="mt-4 text-cosmic/70 font-light leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-10 mt-24 text-center">
        <p className="font-grotesk text-xl md:text-2xl text-cosmic leading-relaxed italic">
          {t.lore.quote}
        </p>
        <Link to="/explore" className="btn-portal inline-flex items-center gap-2 mt-10">
          {t.lore.begin} <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
